import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { catchError, debounceTime, distinctUntilChanged, filter, of, Subject, switchMap, take, takeUntil, tap } from 'rxjs';
import { ConcessaoService } from 'src/app/modules/services/concessao/concessao.service';

import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { formatarDataType } from '../../fomartData';
import { ContractService } from 'src/app/modules/services/contracts/contract.service';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { ServicosIniciaisService } from 'src/app/modules/services/servicos-iniciais/servicos-iniciais.service';
import { RelatoriosContratuaisService } from 'src/app/modules/services/relatorios-contratuais/relatorios-contratuais.service';
import { AfericaoRelatorioService } from 'src/app/modules/services/afericao-relatorio/afericao-relatorio.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { AmpliacaoService } from 'src/app/modules/services/ampliacao/ampliacao.service';
import { RelatoriosOperacionaisService } from 'src/app/modules/services/relatorios-operacionais/relatorios-operacionais.service';
import { ProjetosService } from 'src/app/modules/services/projetos/projetos.service';
import { ProfileService } from 'src/app/modules/services/profile/profile.service';
import { FeriadoService } from 'src/app/modules/services/feriado/feriado.service';
import { AnalisesProjetoService } from 'src/app/modules/services/analises-projeto/analises-projeto.service';
interface Municipio {
  id: string; // O tipo do seu ID é uma string, conforme a imagem
  nome: string;
  codigoIbge: string;
  ddd: string;
  uf: string;
}
@Component({
  selector: 'app-modal-filters',
  templateUrl: './modal-filters.component.html',
  styleUrls: ['./modal-filters.component.scss']
})
export class ModalFiltersComponent implements OnInit {
  // ========== Forms ==========
  form!: FormGroup;
  formUser!: FormGroup;
  formContract!: FormGroup;
  formServicoInicial!: FormGroup;
  formServicoAmpliacao!: FormGroup;
  formAfericaoInicial!: FormGroup;
  formAfericaoRelatorio!: FormGroup;
  formAfericaoAmpliacao!: FormGroup;
  formAfericaoOperacional!: FormGroup;
  formRelatorioOperacional!: FormGroup;
  formRelatorioContratual!: FormGroup;
  formProjetos!: FormGroup;
  formFeriados!: FormGroup;
  formAnalisesProjeto!: FormGroup;
  // ========== Form Field Enable Flags ==========
  cepEnable = false;
  cpfEnable = false;
  nameEnable = false;
  emailEnable = false;

  // ========== Metadata / Tipos ==========
  type: any;
  concessaoTypes: any[] = [];

  tipoContract = '';
  numeroContrato = '';
  entidade = '';
  labelPerfilSelecionado:string = '';
  // ========== Form Controls: Genéricos ==========

  // ========== Form Controls: Contratos ==========
  searchControlContracts = new FormControl();
  filteredOptionsContracts: any[] = [];
  selectedOptionContracts: any;

   searchControlContractsActives = new FormControl();
  filteredOptionsContractsActives: any[] = [];
  allContractsActives: any[] = [];
  selectedOptionContractsActives: any;

  // ========== Form Controls: Responsável (Análises de Projeto) ==========
  searchControlResponsavelAnalise = new FormControl();
  filteredOptionsResponsavelAnalise: any[] = [];
  selectedOptionResponsavelAnalise: any;
  obrasAnalisesProjeto: any[] = [];

  // ========== Form Controls: Relatorios ==========
  searchControlRelatorios = new FormControl();
  filteredOptionsRelatorios: any[] = [];
  selectedOptionRelatorios: any;

  // ========== Form Controls: Tipo de Contratos ==========
  searchControlContract = new FormControl();
  filteredOptionsContract: any[] = [];
  selectedOptionContract: any;

  // ========== Form Controls: Entidades ==========
  searchControlEntidades = new FormControl();
  filteredOptionsEntidades: any[] = [];
  selectedOptionEntidade: any;

  // ========== Form Controls: Escopo ==========
  searchControlEscopo = new FormControl();
  filteredOptionsEscopo: any[] = [];
  selectedOptionEscopo: any;

  // ========== Form Controls: Tipo de Serviço ==========
  searchControlTipoServico = new FormControl();
  filteredOptionsTipoServico: any[] = [];
  selectedOptionTipoServico: any;

  // ========== Range Pickers ==========
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangeDataAssinatura = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangeDataEficacia = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangePrazo = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangePrazoInicial = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangePrazoFinal = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangePrazoVigenteInicial = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangePrazoVigenteFinal = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangeAfericaoPrazo = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
   rangePrazoVigenciaFinal = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  rangePeriodoReferencia = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  // ========== Datas: Filtros ==========
  dataInicio: string = '';
  dataFinal: string = '';

  dataAssinaturaInicio: string = '';
  dataAssinaturaFinal: string = '';

  dataEficaciaInicio: string = '';
  dataEficaciaFinal: string = '';

  dataPrazoInicio: string = '';
  dataPrazoFinal: string = '';

  dataAfericaoPrazoInicio: string = '';
  dataAfericaoPrazoFinal: string = '';

  prazoVigenteFinalInicio: string = '';
  prazoVigenteFinalFim: string = '';

  dataPrazoInicialInicio: string = '';
  dataPrazoInicialFim: string = '';

  dataPrazoFinalInicio: string = '';
  dataPrazoFinalFim: string = '';

  dataPrazoVigenteInicialInicio: string = '';
  dataPrazoVigenteInicialFim: string = '';

  dataPrazoVigenteFinalInicio: string = '';
  dataPrazoVigenteFinalFim: string = '';

  dataPeriodoReferenciaInicio: string = '';
  dataPeriodoReferenciaFim: string = '';

  areasFuncionais: any[] = [];
  nomesRelatorios: any[] = [];
  tiposRelatorios: any[] = [];
  arrayAnos: any[] = [];
  tiposRelatoriosOperacionais: any[] = [];
  nomeRelatorio: any;
  tiposObra: any[] = [];
  tiposProjetos: any[] = [];
  tiposInvestimentos: any[] = [];
  sentidos = [
    { id: 1, nome: 'Crescente' },
    { id: 2, nome: 'Decrescente' },
    { id: 3, nome: 'Ambos' },
    { id: 4, nome: 'Norte' },
    { id: 5, nome: 'Sul' },
  ];
  origensObra: any[] = [];
  sentidosObra: any[] = [];
  municipios: any[] = [];
  idContrato:string = '';
  // Mapas para simplificar as lógicas de populacionamento, filtragem e limpeza
  private _populators = new Map();
  private _handlers = new Map();
  private _clearers = new Map();
  private _emptyCheckers = new Map();

  // O array que será exibido no dropdown, após ser filtrado
  municipiosFiltrados: Municipio[] = [];

  // O array para manter os municípios selecionados no topo
  municipiosOrdenados: Municipio[] = [];
  municipioSearchCtrl = new FormControl('');

  private _onDestroy = new Subject<void>();

  tipoEntidade: any;
  entities: any[] = [];
  perfisUsuario: any[] = [];
  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModalFiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public filters_data: any,

    private contractService: ContractService,
    private entitieService: EntitiesService,
    private snackbarService: OpenSnackbarService,
    private servicosIniciais: ServicosIniciaisService,
    private afericaoRelatorioService: AfericaoRelatorioService,
    private relatoriosContratuaisService: RelatoriosContratuaisService,
    private relatoriosOperacionaisService: RelatoriosOperacionaisService,
    private projetosService: ProjetosService,
    private feriadoService: FeriadoService,
    public toastService: ToastService,
    private ampliacaoService: AmpliacaoService,
    private profileService: ProfileService,
    private analisesProjetoService: AnalisesProjetoService
  ) {
    if(this.filters_data.idContrato){
      this.idContrato = this.filters_data.idContrato;

    }

    iconRegistry.addSvgIcon(
      'filter-icon',
      sanitizer.bypassSecurityTrustResourceUrl('assets/create-user/svgs/trailing-icon.svg')
    );

    this.initializeForms();
    this.initializeMaps();
    this.initializeRangeSubscriptions();
    if(this.isEntitieFilter()){
      this.getEntitieTypes();
    }
    if(this.isUserFilter()){
      this.getProfiles();
    }
    if(this.filters_data.type === 'relatorioOperacional' || this.filters_data.type === 'afericaoOperacional'){
      this.getNomeRelatorio();
      this.getTiposRelatorios()
    }
    if(this.filters_data.type === 'relatorioContratual' || this.filters_data.type === 'afericaoRelatorio'){
      this.getAreasFuncionais();
      this.getTiposRelatoriosContratuais();
    }
    if(this.filters_data.type === 'projetos'){
      this.getTiposProjetos();
    }
    if(this.filters_data.type === 'feriados'){
      this.getAnosDisponiveis();
    }

    if(this.filters_data.type === 'servicosAmpliacao' || this.filters_data.type === 'afericaoAmpliacao' || this.filters_data.type === 'relatorioContratual' ){
      this.carregarTipos();
      this.carregarMunicipios();
       this.municipioSearchCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((value: any ) => {
        this.filterMunicipios(value);
      });
    }
  }

  private initializeMaps(): void {
    this._populators.set('entitie', this.populateEntitieForm.bind(this));
    this._populators.set('user', this.populateUserForm.bind(this));
    this._populators.set('contract', this.populateContractForm.bind(this));
    this._populators.set('servicosIniciais', this.populateServicoIniciaisForm.bind(this));
    this._populators.set('afericaoInicial', this.populateAfericaoInicialForm.bind(this));
    this._populators.set('afericaoRelatorio', this.populateAfericaoRelatoriosForm.bind(this));
    this._populators.set('servicosAmpliacao', this.populateServicoAmpliacaoForm.bind(this));
    this._populators.set('afericaoAmpliacao', this.populateAfericaoAmpliacaoForm.bind(this));
    this._populators.set('relatorioOperacional', this.populateRelatorioOperacionalForm.bind(this));
    this._populators.set('relatorioContratual', this.populateRelatorioContratualForm.bind(this));
    this._populators.set('afericaoOperacional', this.populateAfericaoOperacionalForm.bind(this));
    this._populators.set('projetos', this.populateProjetosForm.bind(this));
    this._populators.set('feriados', this.populateFeriadosForm.bind(this));
    this._populators.set('analisesProjeto', this.populateAnalisesProjetoForm.bind(this));

    this._handlers.set('entitie', () => this.dialogRef.close(this.buildEntitieFilterData()));
    this._handlers.set('user', () => this.dialogRef.close(this.buildUserFilterData()));
    this._handlers.set('contract', () => this.dialogRef.close(this.buildContractFilterData()));
    this._handlers.set('servicosIniciais', () => this.dialogRef.close(this.buildServicosIniciaisFilterData()));
    this._handlers.set('afericaoInicial', () => this.dialogRef.close(this.buildAfericaoInicialFilterData()));
    this._handlers.set('afericaoRelatorio', () => this.dialogRef.close(this.buildAfericaoRelatoriosFilterData()));
    this._handlers.set('servicosAmpliacao', () => this.dialogRef.close(this.buildServicosAmpliacaoFilterData()));
    this._handlers.set('afericaoAmpliacao', () => this.dialogRef.close(this.buildAfericaoAmpliacaoFilterData()));
    this._handlers.set('relatorioOperacional', () => this.dialogRef.close(this.buildRelatorioOperacionalFilterData()));
    this._handlers.set('relatorioContratual', () => this.dialogRef.close(this.buildRelatorioContratualFilterData()));
    this._handlers.set('afericaoOperacional', () => this.dialogRef.close(this.buildAfericaoOperacionalFilterData()));
    this._handlers.set('projetos', () => this.dialogRef.close(this.buildProjetosFilterData()));
    this._handlers.set('feriados', () => this.dialogRef.close(this.buildFeriadosFilterData()));
    this._handlers.set('analisesProjeto', () => this.dialogRef.close(this.buildAnalisesProjetoFilterData()));


    this._clearers.set('entitie', this.clearEntitieFields.bind(this));
    this._clearers.set('user', this.clearUserFields.bind(this));
    this._clearers.set('contract', this.clearContractFields.bind(this));
    this._clearers.set('servicosIniciais', this.clearServicoInicialFields.bind(this));
    this._clearers.set('afericaoInicial', this.clearAfericaoInicialFields.bind(this));
    this._clearers.set('afericaoRelatorio', this.clearAfericaoRelatoriosFields.bind(this));
    this._clearers.set('servicosAmpliacao', this.clearServicoAmpliacaoFields.bind(this));
    this._clearers.set('afericaoAmpliacao', this.clearAfericaoAmpliacaoFields.bind(this));
    this._clearers.set('relatorioOperacional', this.clearRelatorioOperacionalFields.bind(this));
    this._clearers.set('relatorioContratual', this.clearRelatorioContratualFields.bind(this));
    this._clearers.set('afericaoOperacional', this.clearAfericaoOperacionalFields.bind(this));
    this._clearers.set('projetos', this.clearProjetosFields.bind(this));
    this._clearers.set('feriados', this.clearFeriadosFields.bind(this));
    this._clearers.set('analisesProjeto', this.clearAnalisesProjetoFields.bind(this));

    this._emptyCheckers.set('contract', this.isContractEmpty.bind(this));
    this._emptyCheckers.set('servicosAmpliacao', this.isServicosAmpliacaoEmpty.bind(this));
    this._emptyCheckers.set('afericaoAmpliacao', this.isAfericaoAmpliacaoEmpty.bind(this));
  }

  private initializeForms(): void {
    this.form = this.fb.group({
      cep: [''],
      cpfRepLegal: [''],
      nomeRepLegal: [''],
      emailEmpresa: [''],
      tipoEntidade: ['']
    });

     this.formUser = this.fb.group({
      perfilUsuario: ['']
     });


    this.formContract = this.fb.group({
      dataEficaciaInicio: [''],
      dataEficaciaFinal: [''],
      dataAssinaturaInicio: [''],
      dataAssinaturaFinal: [''],
      medidaProrrogavelAte: [''],
      prorrogavelAte: [''],
      dataInicio: [''],
      dataFinal: [''],
      entidade: [''],
      tipoContract: ['']
    });

    this.formServicoInicial = this.fb.group({
      nomeEscopo: [''],
      nomeTipoServico: [''],
      parametroDesempenho: [''],
      inicioPrazoAtendimento: [''],
      medidaInicioPrazoAtendimento: [''],
      fimPrazoAtendimento: [''],
      medidaFimPrazoAtendimento: [''],
      valor: [''],
      medidaValor: [''],
      periodo: [false]
    });
  this.formServicoAmpliacao = this.fb.group({
      codigo: [''],
      idTipoObra: [null],
      kmInicial: [null, Validators.min(0)],
      kmFinal: [null, Validators.min(0)],
      prazoVigenteInicial: [null],
      prazoVigenteFinal: [null],
      kmExtensao: [null, Validators.min(0)]
    });
    this.formAfericaoInicial = this.fb.group({
      nomeEscopo: [''],
      nomeTipoServico: [''],
      inicioPrazo: [''],
      fimPrazo: [''],
      dataAfericaoInicio: [''],
      dataAfericaoFim: [''],
      valor: [''],
      medidaValor: [''],
      contractName: ['']
    });
    this.formAfericaoRelatorio = this.fb.group({
      nomeRelatorio: [''],
      prazoInicio: [''],
      prazoFim: [''],
      dataAfericaoInicio: [''],
      dataAfericaoFim: [''],
      contractName: [''],
      situacaoPrazo: [null]
    });
    this.formAfericaoOperacional = this.fb.group({
      nomeRelatorio: [''],
      nomeTipoRelatorio: [''],
      itemContratual: [''],
      prazoInicio: [''],
      prazoFim: [''],
      dataAfericaoInicio: [''],
      dataAfericaoFim: [''],
      contractName: [''],
      situacaoPrazo: [null]
    });

    this.formAfericaoAmpliacao = this.fb.group({
      anoConclusao: [null], // Mantenha este para a entrada mascarada
      idsMunicipios: [[]],
      rodovia: [''],
      nomeOrigemObra: [''],
      nomeTipoObra: [''],
      sentido: [''],
      segmentoHomogeneo: [''],
      kmInicialInicio: [''],
      kmInicialFim: [''],
      kmFinalInicio: [''],
      kmFinalFim: [''],
      kmCampoInicialInicio: [''],
      kmCampoInicialFim: [''],
      kmCampoFinalInicio: [''],
      kmCampoFinalFim: [''],
      naturezaPrazo: [''],
      prazoInicialInicio: [''],
      prazoInicialFim: [''],
      prazoFinalInicio: [''],
      prazoFinalFim: [''],
      prazoVigenteInicialInicio: [''],
      prazoVigenteInicialFim: [''],
      prazoVigenteFinalInicio: [''],
      prazoVigenteFinalFim: [''],
      valorObraInicio: [''],
      valorObraFim: [''],
      valorObraAtualizadoInicio: [''],
      valorObraAtualizadoFim: [''],
      latitudeInicialInicio: [''],
      latitudeInicialFim: [''],
      latitudeFinalInicio: [''],
      latitudeFinalFim: [''],
      longitudeInicialInicio: [''],
      longitudeInicialFim: [''],
      longitudeFinalInicio: [''],
      longitudeFinalFim: [''],
    });
    this.formRelatorioOperacional = this.fb.group({
      prazoInicio: [''],
      prazoFim: [''],
      nomeTipoRelatorioVinculado: [''],
      situacaoPrazo: [null],
      nomeAreaFuncional: [''],
      itemContratual: [''],
      periodoReferenciaInicio: [''],
      periodoReferenciaFim: [''],
    });
    this.formRelatorioContratual = this.fb.group({
      prazoInicio: [''],
      prazoFim: [''],
      nomeAreaFuncional: [''],
      nomeTipoRelatorio: [''],
      situacaoPrazo: [null],
      itemContratual: [''],
      periodoReferenciaInicio: [''],
      periodoReferenciaFim: [''],
    });
    this.formProjetos = this.fb.group({
      contractNumber: [''],
      codigo: [''],
      nomeTipoProjeto: [''],
    });
    this.formFeriados = this.fb.group({
      anos: [''],
    });

    this.formAnalisesProjeto = this.fb.group({
      idContrato: [''],
      contratoDisplay: [''],
      idObra: [''],
      obraDisplay: [''],
      idResponsavel: [''],
      responsavelDisplay: [''],
      prazoInicio: [''],
      prazoFim: [''],
      foraDoPrazo: [null],
    });

  }


  private initializeRangeSubscriptions(): void {
    this.subscribeToRangeChanges(this.rangeDataAssinatura, 'dataAssinatura');
    this.subscribeToRangeChanges(this.rangeDataEficacia, 'dataEficacia');
    this.subscribeToRangeChanges(this.range, 'data');
    this.subscribeToRangeChanges(this.rangePrazo, 'dataPrazo');
    this.subscribeToRangeChanges(this.rangeAfericaoPrazo, 'dataAfericaoPrazo');
    this.subscribeToRangeChanges(this.rangePrazoVigenciaFinal, 'dataAfericaoAmpliacao')
    this.subscribeToRangeChanges(this.rangePrazoInicial, 'dataPrazoInicial')
    this.subscribeToRangeChanges(this.rangePrazoFinal, 'dataPrazoFinal')
    this.subscribeToRangeChanges(this.rangePrazoVigenteInicial, 'dataPrazoVigenteInicial')
    this.subscribeToRangeChanges(this.rangePrazoVigenteFinal, 'dataPrazoVigenteFinal')
    this.subscribeToRangeChanges(this.rangePeriodoReferencia, 'dataPeriodoReferencia')
  }

  private subscribeToRangeChanges(range: FormGroup, rangeType: string): void {
    range.valueChanges
      .pipe(
        tap((value: any) => {

          if (value.start && value.end) {
            const start = formatarDataType(value.start);
            const end = formatarDataType(value.end);
            this.updateRangeData(rangeType, start, end);
          }
        }),
        filter((value) => value.start != null && value.end != null)
      )
      .subscribe();
  }

  private updateRangeData(rangeType: string, start: string, end: string): void {
    switch (rangeType) {
      case 'dataAssinatura':
        this.dataAssinaturaInicio = start;
        this.dataAssinaturaFinal = end;
        break;
      case 'dataEficacia':
        this.dataEficaciaInicio = start;
        this.dataEficaciaFinal = end;
        break;
      case 'dataPrazo':
        this.dataPrazoInicio = start;
        this.dataPrazoFinal = end;
        break;
      case 'dataAfericaoPrazo':
        this.dataAfericaoPrazoInicio = start;
        this.dataAfericaoPrazoFinal = end;
        break;
      case 'dataAfericaoAmpliacao':
        this.prazoVigenteFinalInicio = start;
        this.prazoVigenteFinalFim = end;
        break;
      case 'dataPrazoInicial':
        this.dataPrazoInicialInicio = start;
        this.dataPrazoInicialFim = end;
        break;
      case 'dataPrazoFinal':
        this.dataPrazoFinalInicio = start;
        this.dataPrazoFinalFim = end;
        break;
      case 'dataPrazoVigenteInicial':
        this.dataPrazoVigenteInicialInicio = start;
        this.dataPrazoVigenteInicialFim = end;
        break;
      case 'dataPrazoVigenteFinal':
        this.dataPrazoVigenteFinalInicio = start;
        this.dataPrazoVigenteFinalFim = end;
        break;
      case 'dataPeriodoReferencia':
        this.dataPeriodoReferenciaInicio = start;
        this.dataPeriodoReferenciaFim = end;
        break;
      case 'data':
        this.dataInicio = start;
        this.dataFinal = end;
        break;
    }
  }

  ngOnInit(): void {
    if (this.isContractFilter()) {
      this.getConcessionarias();
      this.getTipoContratos();
    }
    if (this.isServicosIniciaisFilter() || this.isAfericaoInicialFilter()) {
      this.loadInitialData();
    }
    if (this.filters_data.type) {
      this.checkPopulating(this.filters_data);
    }
    this.setupSearchSubscriptions();
  }

  checkPopulating(values: any): void {
    const populator = this._populators.get(this.filters_data.type);
    if (populator) {
      populator(values);
    } else {
      console.warn(`Tipo de filtro desconhecido: ${this.filters_data.type}`);
    }
  }

  private setupSearchSubscriptions(): void {
    this.setupEntidadesSearch();
    this.setupContractSearch();
    this.setupContractsSearch();
    this.setupRelatoriosSearch();
    this.setupContractsAtivosSearch();
    this.setupResponsavelAnaliseSearch();
  }

  private setupResponsavelAnaliseSearch(): void {
    this.searchControlResponsavelAnalise.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value =>
        this.analisesProjetoService.getFiltrosResponsaveis(typeof value === 'string' ? value.trim() : '').pipe(
          catchError(() => of([]))
        )
      )
    ).subscribe((results: any) => {
      this.filteredOptionsResponsavelAnalise = results || [];
    });
  }

  private setupEntidadesSearch(): void {
    this.searchControlEntidades.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value =>
        this.entitieService.getEntities(0, '', '', '', value, value).pipe(
          catchError(() => of([]))
        )
      )
    ).subscribe((results: any) => {
      this.filteredOptionsEntidades = results.content;
    });
  }
  private setupContractSearch(): void {
    this.searchControlContract.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value =>
        this.contractService.getContractType().pipe(
          catchError(() => of([]))
        )
      )
    ).subscribe((results: any) => {
      this.filteredOptionsContract = results;
    });
  }
  private setupContractsSearch(): void {
    this.searchControlContracts.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value =>
        this.contractService.getContracts(0, 'asc', 'contractName', '', '', '', '', '', '', '', value?.trim()).pipe(
          catchError(() => of([]))
        )
      )
    ).subscribe((results: any) => {
      this.filteredOptionsContracts = results.content;
    });

  }
  private setupContractsAtivosSearch(): void {
    if (!this.isProjetosFilter() && !this.isAnalisesProjetoFilter()) {
      return;
    }

    const contratos$ = this.isProjetosFilter()
      ? this.projetosService.buscarContratosParaFiltro('contractNumber', 'asc')
      : this.contractService.getContractsActives(0, 'asc', 'contractNumber', '', '', '', '', '', '', '', '', undefined, undefined, undefined, undefined, undefined, undefined, undefined, 50);

    contratos$
      .pipe(catchError(() => of([])))
      .subscribe((results: any) => {
        this.allContractsActives = Array.isArray(results) ? results : (results.content || []);
        this.filteredOptionsContractsActives = [...this.allContractsActives];
      });

    this.searchControlContractsActives.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    ).subscribe((value: any) => {
      if (!value || typeof value !== 'string') {
        this.filteredOptionsContractsActives = [...this.allContractsActives];
        return;
      }
      const search = value.toLowerCase().trim();
      this.filteredOptionsContractsActives = this.allContractsActives.filter((contract: any) =>
        contract.contractNumber?.toLowerCase().includes(search) ||
        contract.contractName?.toLowerCase().includes(search)
      );
    });
  }
  private setupRelatoriosSearch(): void {
    this.searchControlRelatorios.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value =>{
        const filterData = {
          value : {
            nomeRelatorio:value?.trim()
          }
        }
        return this.afericaoRelatorioService.getAfericaoRelatorios(10, 0,'asc','contrato.contractNumber', '', filterData, '').pipe(
          catchError(() => of([]))
        )
      }

      )
    ).subscribe((results: any) => {
      this.filteredOptionsRelatorios = results.content;
    });
  }
  private loadInitialData(): void {
    this.servicosIniciais.getEscopos().subscribe({
      next: (res: any) => {
        this.filteredOptionsEscopo = res.content;
      },
      error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error');
      }
    });

    this.servicosIniciais.getTipoServicos().subscribe({
      next: (res: any) => {
        this.filteredOptionsTipoServico = res.content;
      },
      error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error');
      }
    });
  }

  getConcessionarias() {
    this.entitieService.getEntities(0, '', '', 'Concessionária', '', '').subscribe((results: any) => {
      this.filteredOptionsEntidades = results.content
    })
  }
  getTipoContratos() {
    this.contractService.getContractType().subscribe((results: any) => {
      this.filteredOptionsContract = results
    })
  }
  carregarMunicipios(nome?: string) {
    this.ampliacaoService.getMunicipios(0, 20, nome).subscribe({
      next: (res: any) => {
        const oldMunicipios = this.municipiosOrdenados;
        const idsMunicipios = this.formAfericaoAmpliacao.value.idsMunicipios;
        this.municipios = res.content;
        let municipiosSelecionados:any = [];
        if(idsMunicipios.length > 0){
           municipiosSelecionados = oldMunicipios.filter(mun => idsMunicipios.includes(mun.id));
        }
        if(municipiosSelecionados.length > 0){
          this.municipios = this.municipios.filter(mun => !idsMunicipios.includes(mun.id));
           this.municipiosOrdenados = [...municipiosSelecionados,...this.municipios];
        }else{
           this.municipiosOrdenados = [...this.municipios];
        }
      },
      error: err => console.error('Erro ao carregar municípios', err)
    });
  }

  private populateEntitieForm(dataObject: any): void {
    const data = dataObject?.propsEntities;
    const formValue = data.value;
    const formValues: any = {};

    // Lógica para os outros campos
    const keys = ['cep', 'cpfRepLegal', 'nomeRepLegal', 'emailEmpresa', 'tipoEntidade'];
    keys.forEach(key => {
      if (formValue?.[key] !== undefined && formValue?.[key] !== null) {
        formValues[key] = formValue[key];
      }
    });

    this.form?.patchValue(formValues);
}

  private populateUserForm(dataObject: any): void {
    const data = dataObject?.propsUser;
    const formValue = data.value;
    const formValues: any = {};

    // Lógica para os outros campos
    const keys = ['perfilUsuario'];
    keys.forEach(key => {
      if (formValue?.[key] !== undefined && formValue?.[key] !== null) {
        formValues[key] = formValue[key];
      }
    });

    this.formUser?.patchValue(formValues);
}

private populateContractForm(dataObject: any): void {
  const props = dataObject?.propsContract;

  this.patchDateRange(props?.dataEficaciaInicio, 'start', this.rangeDataEficacia, (val) => this.dataEficaciaInicio = val);
  this.patchDateRange(props?.dataEficaciaFinal, 'end', this.rangeDataEficacia, (val) => this.dataEficaciaFinal = val);
  this.patchDateRange(props?.dataAssinaturaInicio, 'start', this.rangeDataAssinatura, (val) => this.dataAssinaturaInicio = val);
  this.patchDateRange(props?.dataAssinaturaFinal, 'end', this.rangeDataAssinatura, (val) => this.dataAssinaturaFinal = val);
  this.patchFormValue('medidaProrrogavelAte', props?.medida, this.formContract);

  this.patchFormValue('prorrogavelAte', props?.prorrogavelAte, this.formContract);
  this.patchDateRange(props?.dataInicio, 'start', this.range);
  this.patchDateRange(props?.dataFinal, 'end', this.range, (val) => this.dataFinal = val);

  if (props?.entidade) {
    this.entidade = props.entidade;
    this.searchControlEntidades?.setValue(props.entidade, { emitEvent: false });
  }

  if (props?.tipoContract) {
    this.tipoContract = props.tipoContract;
    this.searchControlContract?.setValue(props.tipoContract, { emitEvent: false });
  }
}

private populateServicoIniciaisForm(dataObject: any): void {
  const data = dataObject?.propsServicosIniciais;
  if (!data || !data.value) return;
  const formValue = data.value;
  const keys = ['nomeEscopo', 'nomeTipoServico', 'parametroDesempenho', 'inicioPrazoAtendimento', 'medidaInicioPrazoAtendimento', 'fimPrazoAtendimento', 'dataAfericaoInicio', 'dataAfericaoFim', 'medidaFimPrazoAtendimento', 'valor', 'medidaValor', 'periodo'];
  const formValues: any = {};
  keys.forEach(key => {
    if (formValue?.[key] !== undefined && formValue?.[key] !== null) {
      formValues[key] = formValue[key];
    }
  });
  this.formServicoInicial?.patchValue(formValues);
}

private populateServicoAmpliacaoForm(dataObject: any): void {
  const data = dataObject?.propsServicosAmpliacao;
  if (!data || !data.value) return;
  const formValue = data.value;
  const keys = ['codigo', 'idTipoObra', 'kmInicial', 'kmFinal', 'prazoVigenteInicial', 'prazoVigenteFinal', 'kmExtensao'];
  const formValues: any = {};
  keys.forEach(key => {
    if (formValue?.[key] !== undefined && formValue?.[key] !== null) {
      formValues[key] = formValue[key];
    }
  });
  this.formServicoAmpliacao?.patchValue(formValues);
  this.carregarMunicipios();
}

private populateAfericaoInicialForm(dataObject: any): void {
  const data = dataObject?.propsAfericaoInicial;
  if (!data || !data.value) return;
  this.patchDateRange(data?.value.inicioPrazo, 'start', this.rangePrazo, (val) => this.dataPrazoInicio = val);
  this.patchDateRange(data?.value.fimPrazo, 'end', this.rangePrazo, (val) => this.dataPrazoFinal = val);
  this.patchDateRange(data?.value.dataAfericaoInicio, 'start', this.rangeAfericaoPrazo, (val) => this.dataAfericaoPrazoInicio = val);
  this.patchDateRange(data?.value.dataAfericaoFim, 'end', this.rangeAfericaoPrazo, (val) => this.dataAfericaoPrazoFinal = val);

  const keys = ['nomeEscopo', 'nomeTipoServico', 'parametroDesempenho', 'valor', 'medidaValor', 'contractName'];
  const formValues: any = {};
  keys.forEach(key => {
    if (data?.value?.[key] !== undefined && data?.value?.[key] !== null) {
      formValues[key] = data.value[key];
    }
  });
  this.formAfericaoInicial?.patchValue(formValues);
}

private populateAfericaoRelatoriosForm(dataObject: any): void {
  const data = dataObject?.propsAfericaoRelatorios;
  if (!data || !data.value) return;
  this.patchDateRange(data?.value.prazoInicio, 'start', this.rangePrazo, (val) => this.dataPrazoInicio = val);
  this.patchDateRange(data?.value.prazoFim, 'end', this.rangePrazo, (val) => this.dataPrazoFinal = val);
  this.patchDateRange(data?.value.dataAfericaoInicio, 'start', this.rangeAfericaoPrazo, (val) => this.dataAfericaoPrazoInicio = val);
  this.patchDateRange(data?.value.dataAfericaoFim, 'end', this.rangeAfericaoPrazo, (val) => this.dataAfericaoPrazoFinal = val);


  const keys = ['nomeRelatorio', 'prazoInicio', 'prazoFim', 'dataAfericaoInicio', 'dataAfericaoFim', 'contractName', 'situacaoPrazo'];
  const formValues: any = {};
  keys.forEach(key => {
    if (data?.value?.[key] !== undefined && data?.value?.[key] !== null) {
      formValues[key] = data.value[key];
    }
  });
  this.formAfericaoRelatorio?.patchValue(formValues);

  if(data?.value?.contractName) {
    this.searchControlContracts?.setValue(data.value.contractName, { emitEvent: false });
  }
  if(data?.value?.nomeRelatorio) {
    this.searchControlRelatorios?.setValue(data.value.nomeRelatorio, { emitEvent: false });
  }
}

private populateAfericaoAmpliacaoForm(dataObject: any): void {
  const data = dataObject?.propsAfericaoAmpliacaos;
  if (!data || !data.value) return;
  this.patchDateRange(data?.value.prazoInicialInicio, 'start', this.rangePrazoInicial, (val) => this.dataPrazoInicialInicio = val);
  this.patchDateRange(data?.value.prazoInicialFim, 'end', this.rangePrazoInicial, (val) => this.dataPrazoInicialFim = val);

  this.patchDateRange(data?.value.prazoFinalInicio, 'start', this.rangePrazoFinal, (val) => this.dataPrazoFinalInicio = val);
  this.patchDateRange(data?.value.prazoFinalFim, 'end', this.rangePrazoFinal, (val) => this.dataPrazoFinalFim = val);

  this.patchDateRange(data?.value.prazoVigenteInicialInicio, 'start', this.rangePrazoVigenteInicial, (val) => this.dataPrazoVigenteInicialInicio = val);
  this.patchDateRange(data?.value.prazoVigenteInicialFim, 'end', this.rangePrazoVigenteInicial, (val) => this.dataPrazoVigenteInicialFim = val);

  this.patchDateRange(data?.value.prazoVigenteFinalInicio, 'start', this.rangePrazoVigenteFinal, (val) => this.dataPrazoVigenteFinalInicio = val);
  this.patchDateRange(data?.value.prazoVigenteFinalFim, 'end', this.rangePrazoVigenteFinal, (val) => this.dataPrazoVigenteFinalFim = val);

  const formValue = data.value;
  const formValues: any = {};

  formValues.anoConclusao = formValue?.anoConclusao;
  formValues.kmInicial = formValue?.kmInicial;
  formValues.kmFinal = formValue?.kmFinal;

  // Lógica para os outros campos
  const keys = [
    'idsMunicipios',
    'rodovia',
    'prazoVigenteFinal',
    'nomeTipoRelatorioVinculado',
    'nomeOrigemObra',
    'nomeTipoObra',
    'sentido',
    'segmentoHomogeneo',
    'kmInicialInicio',
    'kmInicialFim',
    'kmFinalInicio',
    'kmFinalFim',
    'kmCampoInicialInicio',
    'kmCampoInicialFim',
    'kmCampoFinalInicio',
    'kmCampoFinalFim',
    'naturezaPrazo',
    'valorObraInicio',
    'valorObraFim',
    'valorObraAtualizadoInicio',
    'valorObraAtualizadoFim',
    'latitudeInicialInicio',
    'latitudeInicialFim',
    'latitudeFinalInicio',
    'latitudeFinalFim',
    'longitudeInicialInicio',
    'longitudeInicialFim',
    'longitudeFinalInicio',
    'longitudeFinalFim',
  ];
  keys.forEach(key => {
    if (formValue?.[key] !== undefined && formValue?.[key] !== null) {
      formValues[key] = formValue[key];
    }
  });

  this.formAfericaoAmpliacao?.patchValue(formValues);
}
private populateRelatorioOperacionalForm(dataObject: any): void {
  const data = dataObject?.propsRelatorioOperacional;
  if (!data || !data.value) return;
  this.patchDateRange(data?.value.prazoInicio, 'start', this.rangePrazo, (val) => this.dataPrazoInicio = val);
  this.patchDateRange(data?.value.prazoFim, 'end', this.rangePrazo, (val) => this.dataPrazoFinal = val);
  this.patchDateRange(data?.value.periodoReferenciaInicio, 'start', this.rangePeriodoReferencia, (val) => this.dataPeriodoReferenciaInicio = val);
  this.patchDateRange(data?.value.periodoReferenciaFim, 'end', this.rangePeriodoReferencia, (val) => this.dataPeriodoReferenciaFim = val);
  const formValue = data.value;
  const formValues: any = {};

  // Lógica para os outros campos
  const keys = ['nomeTipoRelatorioVinculado', 'situacaoPrazo', 'nomeAreaFuncional', 'itemContratual'];
  keys.forEach(key => {
    if (formValue?.[key] !== undefined && formValue?.[key] !== null) {
      formValues[key] = formValue[key];
    }
  });

  this.formRelatorioOperacional?.patchValue(formValues);
}
private populateRelatorioContratualForm(dataObject: any): void {
  const data = dataObject?.propsRelatorioContratual;
  if (!data || !data.value) return;
  this.patchDateRange(data?.value.prazoInicio, 'start', this.rangePrazo, (val) => this.dataPrazoInicio = val);
  this.patchDateRange(data?.value.prazoFim, 'end', this.rangePrazo, (val) => this.dataPrazoFinal = val);
  this.patchDateRange(data?.value.periodoReferenciaInicio, 'start', this.rangePeriodoReferencia, (val) => this.dataPeriodoReferenciaInicio = val);
  this.patchDateRange(data?.value.periodoReferenciaFim, 'end', this.rangePeriodoReferencia, (val) => this.dataPeriodoReferenciaFim = val);
  const formValue = data.value;
  const formValues: any = {};

  // Lógica para os outros campos
  const keys = ['nomeAreaFuncional', 'nomeTipoRelatorio', 'situacaoPrazo', 'itemContratual'];
  keys.forEach(key => {
    if (formValue?.[key] !== undefined && formValue?.[key] !== null) {
      formValues[key] = formValue[key];
    }
  });

  this.formRelatorioContratual?.patchValue(formValues);
}

private populateAfericaoOperacionalForm(dataObject: any): void {
  const data = dataObject?.propsAfericaoOperacional;
  if (!data || !data.value) return;
  this.patchDateRange(data?.value.prazoInicio, 'start', this.rangePrazo, (val) => this.dataPrazoInicio = val);
  this.patchDateRange(data?.value.prazoFim, 'end', this.rangePrazo, (val) => this.dataPrazoFinal = val);
  this.patchDateRange(data?.value.dataAfericaoInicio, 'start', this.rangeAfericaoPrazo, (val) => this.dataAfericaoPrazoInicio = val);
  this.patchDateRange(data?.value.dataAfericaoFim, 'end', this.rangeAfericaoPrazo, (val) => this.dataAfericaoPrazoFinal = val);


  const keys = ['nomeRelatorio', 'prazoInicio', 'prazoFim', 'dataAfericaoInicio', 'dataAfericaoFim', 'contractName', 'itemContratual', 'nomeTipoRelatorio', 'situacaoPrazo'];
  const formValues: any = {};
  keys.forEach(key => {
    if (data?.value?.[key] !== undefined && data?.value?.[key] !== null) {
      formValues[key] = data.value[key];
    }
  });
  this.formAfericaoOperacional?.patchValue(formValues);

  if(data?.value?.contractName) {
    this.searchControlContracts?.setValue(data.value.contractName, { emitEvent: false });
  }
  if(data?.value?.nomeRelatorio) {
    this.searchControlRelatorios?.setValue(data.value.nomeRelatorio, { emitEvent: false });
  }
}
private populateProjetosForm(dataObject: any): void {
  const data = dataObject?.propsProjetos;

  const keys = ['contractNumber', 'codigo', 'nomeTipoProjeto'];
  const formValues: any = {};
  keys.forEach(key => {
    if (data?.value?.[key] !== undefined && data?.value?.[key] !== null) {
      formValues[key] = data.value[key];
    }
  });
  this.formProjetos?.patchValue(formValues);
    if(data?.value?.contractNumber) {
    this.searchControlContractsActives?.setValue(data.value.contractNumber, { emitEvent: false });
  }
}
private populateAnalisesProjetoForm(dataObject: any): void {
  const data = dataObject?.propsAnalisesProjeto;
  const formValue = data?.value;
  if (!formValue) return;

  this.patchDateRange(formValue.prazoInicio, 'start', this.rangePrazo, (val) => this.dataPrazoInicio = val);
  this.patchDateRange(formValue.prazoFim, 'end', this.rangePrazo, (val) => this.dataPrazoFinal = val);

  const keys = ['idContrato', 'contratoDisplay', 'idObra', 'obraDisplay', 'idResponsavel', 'responsavelDisplay', 'prazoInicio', 'prazoFim', 'foraDoPrazo'];
  const formValues: any = {};
  keys.forEach(key => {
    if (formValue[key] !== undefined && formValue[key] !== null) {
      formValues[key] = formValue[key];
    }
  });
  this.formAnalisesProjeto?.patchValue(formValues);

  if (formValue.contratoDisplay) {
    this.searchControlContractsActives?.setValue(formValue.contratoDisplay, { emitEvent: false });
    this.getObrasAnalisesProjeto(formValue.idContrato);
  }
  if (formValue.responsavelDisplay) {
    this.searchControlResponsavelAnalise?.setValue(formValue.responsavelDisplay, { emitEvent: false });
  }
}
private populateFeriadosForm(dataObject: any): void {
  const data = dataObject?.propsFeriados;

  const keys = ['anos'];
  const formValues: any = {};
  keys.forEach(key => {
    if (data?.value?.[key] !== undefined && data?.value?.[key] !== null) {
      formValues[key] = data.value[key];
    }
  });
  this.formFeriados?.patchValue(formValues);
    if(data?.value?.contractNumber) {
    this.searchControlContractsActives?.setValue(data.value.contractNumber, { emitEvent: false });
  }
}

private patchFormValue(key: string, value: any, form: FormGroup, callback?: () => void): void {
  if (value) {
    form.patchValue({ [key]: value });
    callback?.();
  }
}
private patchDateRange(value: any, position: 'start' | 'end', control: FormGroup, setter?: (val: string) => void): void {
    if (value) {
      control.patchValue({ [position]: value });
      setter?.(value);
    }
}
  enableCep() { this.cepEnable = !this.cepEnable; }
  enableCPF() { this.cpfEnable = !this.cpfEnable; }
  enablename() { this.nameEnable = !this.nameEnable; }
  enableEmail() { this.emailEnable = !this.emailEnable; }

  filter(): void {
    const handler = this._handlers.get(this.filters_data.type);
    if (handler) {
      handler();
    } else {
      console.warn(`Tipo de filtro não reconhecido: ${this.filters_data.type}`);
    }
  }

  private buildEntitieFilterData(): any {
    return this.form;
  }

   private buildUserFilterData(): any {
    const data = {
      formUser: this.formUser,
      labelPerfilSelecionado: this.labelPerfilSelecionado
    }
    return data;
  }

  private buildContractFilterData(): any {
     this.formContract.patchValue({
      dataAssinaturaInicio: this.dataAssinaturaInicio,
      dataAssinaturaFinal: this.dataAssinaturaFinal,
      dataEficaciaInicio: this.dataEficaciaInicio,
      dataEficaciaFinal: this.dataEficaciaFinal,
      entidade: this.entidade,
      dataInicio: this.dataInicio,
      dataFinal: this.dataFinal,
      tipoContract: this.tipoContract,
    });
    return this.formContract
  }
  private buildServicosIniciaisFilterData(): any {
    delete this.formServicoInicial.controls['periodo'];
    return this.formServicoInicial;
  }

  private buildServicosAmpliacaoFilterData(): any {
    return this.formServicoAmpliacao;
  }

  private buildAfericaoInicialFilterData(): any {
    this.formAfericaoInicial.patchValue({
      inicioPrazo: this.dataPrazoInicio,
      fimPrazo: this.dataPrazoFinal,
      dataAfericaoInicio: this.dataAfericaoPrazoInicio,
      dataAfericaoFim: this.dataAfericaoPrazoFinal
    });
    return this.formAfericaoInicial;
  }
  private buildAfericaoRelatoriosFilterData(): any {
    this.formAfericaoRelatorio.patchValue({
      prazoInicio: this.dataPrazoInicio,
      prazoFim: this.dataPrazoFinal,
      dataAfericaoInicio: this.dataAfericaoPrazoInicio,
      dataAfericaoFim: this.dataAfericaoPrazoFinal
    });
    return this.formAfericaoRelatorio;
  }
  private buildAfericaoOperacionalFilterData(): any {
    this.formAfericaoOperacional.patchValue({
      prazoInicio: this.dataPrazoInicio,
      prazoFim: this.dataPrazoFinal,
      dataAfericaoInicio: this.dataAfericaoPrazoInicio,
      dataAfericaoFim: this.dataAfericaoPrazoFinal
    });
    return this.formAfericaoOperacional;
  }

   private buildProjetosFilterData(): any {
    return this.formProjetos;
  }
  private buildFeriadosFilterData(): any {
    return this.formFeriados;
  }
  private buildAnalisesProjetoFilterData(): any {
    this.formAnalisesProjeto.patchValue({
      prazoInicio: this.dataPrazoInicio,
      prazoFim: this.dataPrazoFinal,
    });
    return this.formAnalisesProjeto;
  }

 private buildRelatorioOperacionalFilterData(): any {
    this.formRelatorioOperacional.patchValue({
      prazoInicio: this.dataPrazoInicio,
      prazoFim: this.dataPrazoFinal,
      periodoReferenciaInicio: this.dataPeriodoReferenciaInicio,
      periodoReferenciaFim: this.dataPeriodoReferenciaFim,
    });
    return this.formRelatorioOperacional;
  }
   private buildRelatorioContratualFilterData(): any {
    this.formRelatorioContratual.patchValue({
      prazoInicio: this.dataPrazoInicio,
      prazoFim: this.dataPrazoFinal,
      periodoReferenciaInicio: this.dataPeriodoReferenciaInicio,
      periodoReferenciaFim: this.dataPeriodoReferenciaFim,
    });
    return this.formRelatorioContratual;
  }


   private buildAfericaoAmpliacaoFilterData(): any {
    this.formAfericaoAmpliacao.patchValue({
      prazoInicialInicio: this.dataPrazoInicialInicio,
      prazoInicialFim: this.dataPrazoInicialFim,
      prazoFinalInicio: this.dataPrazoFinalInicio,
      prazoFinalFim: this.dataPrazoFinalFim,
      prazoVigenteInicialInicio: this.dataPrazoVigenteInicialInicio,
      prazoVigenteInicialFim: this.dataPrazoVigenteInicialFim,
      prazoVigenteFinalInicio: this.dataPrazoVigenteFinalInicio,
      prazoVigenteFinalFim: this.dataPrazoVigenteFinalFim,
    });
    return this.formAfericaoAmpliacao;
  }
  clear(): void {
    const clearer = this._clearers.get(this.filters_data.type);
    if (clearer) {
      clearer();
      let formToClose;
      switch (this.filters_data.type) {
        case 'entitie': formToClose = this.form; break;
        case 'user': formToClose = this.formUser; break;
        case 'contract': formToClose = this.formContract; break;
        case 'servicosIniciais': formToClose = this.formServicoInicial; break;
        case 'afericaoInicial': formToClose = this.formAfericaoInicial; break;
        case 'afericaoRelatorio': formToClose = this.formAfericaoRelatorio; break;
        case 'servicosAmpliacao': formToClose = this.formServicoAmpliacao; break;
        case 'afericaoAmpliacao': formToClose = this.formAfericaoAmpliacao; break;
        case 'relatorioOperacional': formToClose = this.formRelatorioOperacional; break;
        case 'relatorioContratual': formToClose = this.formRelatorioContratual; break;
        case 'afericaoOperacional': formToClose = this.formAfericaoAmpliacao; break;
        case 'projetos': formToClose = this.formProjetos; break;
        case 'feriados': formToClose = this.formFeriados; break;
        case 'analisesProjeto': formToClose = this.formAnalisesProjeto; break;

        default: formToClose = null;
      }
      this.dialogRef.close(formToClose);
    }
  }


  private clearEntitieFields(): void {
    this.form.reset();
  }

  private clearUserFields(): void {
    this.formUser.reset();
  }

  private clearContractFields(): void {
    this.formContract.reset();

    this.searchControlContract.reset();
    this.searchControlEntidades.reset();
    this.range.reset();
    this.rangeDataAssinatura.reset();
    this.rangeDataEficacia.reset();
    this.dataEficaciaInicio = '';
    this.dataEficaciaFinal = '';
    this.dataAssinaturaInicio = '';
    this.dataAssinaturaFinal = '';

    this.dataInicio = '';
    this.dataFinal = '';
    this.entidade = '';
    this.tipoContract = '';
  }
  private clearServicoInicialFields(): void {
    this.formServicoInicial.reset();
  }
  private clearServicoAmpliacaoFields(): void {
    this.formServicoAmpliacao.reset();
  }
  private clearAfericaoInicialFields(): void {
    this.formAfericaoInicial.reset();
    this.dataPrazoInicio = '';
    this.dataPrazoFinal = '';
    this.dataAfericaoPrazoInicio = '';
    this.dataAfericaoPrazoFinal = '';
    this.searchControlContracts.reset();
    this.rangePrazo.reset();
    this.rangeAfericaoPrazo.reset();
  }
  private clearAfericaoRelatoriosFields(): void {
    this.formAfericaoRelatorio.reset();
    this.dataPrazoInicio = '';
    this.dataPrazoFinal = '';
    this.dataAfericaoPrazoInicio = '';
    this.dataAfericaoPrazoFinal = '';
    this.searchControlContracts.reset();
    this.searchControlRelatorios.reset();
    this.nomeRelatorio = null;
    this.rangePrazo.reset();
    this.rangeAfericaoPrazo.reset();
  }
  private clearAfericaoOperacionalFields(): void {
    this.formAfericaoRelatorio.reset();
    this.dataPrazoInicio = '';
    this.dataPrazoFinal = '';
    this.dataAfericaoPrazoInicio = '';
    this.dataAfericaoPrazoFinal = '';
    this.searchControlContracts.reset();
    this.searchControlRelatorios.reset();
    this.nomeRelatorio = null;
    this.rangePrazo.reset();
    this.rangeAfericaoPrazo.reset();
  }
   private clearProjetosFields(): void {
    this.formProjetos.reset();
     this.searchControlContractsActives.reset();
  }

   private clearAnalisesProjetoFields(): void {
    this.formAnalisesProjeto.reset();
    this.searchControlContractsActives.reset();
    this.searchControlResponsavelAnalise.reset();
    this.obrasAnalisesProjeto = [];
    this.dataPrazoInicio = '';
    this.dataPrazoFinal = '';
    this.rangePrazo.reset();
  }

   private clearFeriadosFields(): void {
    this.formFeriados.reset();
  }


  private clearAfericaoAmpliacaoFields(): void {
    this.formAfericaoAmpliacao.reset();
    this.prazoVigenteFinalInicio = '';
    this.prazoVigenteFinalFim = '';
    this.dataPrazoInicialInicio = '';
    this.dataPrazoInicialFim = '';
    this.dataPrazoFinalInicio = '';
    this.dataPrazoFinalFim = '';
    this.dataPrazoVigenteInicialInicio = '';
    this.dataPrazoVigenteInicialFim = '';
    this.dataPrazoVigenteFinalInicio = '';
    this.dataPrazoVigenteFinalFim = '';
  }
  private clearRelatorioOperacionalFields(): void {
    this.formRelatorioOperacional.reset();
    this.dataPrazoInicio = '';
    this.dataPrazoFinal = '';
    this.dataPeriodoReferenciaInicio = '';
    this.dataPeriodoReferenciaFim = '';
    this.rangePrazo.reset();
    this.rangePeriodoReferencia.reset();
  }
  private clearRelatorioContratualFields(): void {
    this.formRelatorioContratual.reset();
    this.dataPrazoInicio = '';
    this.dataPrazoFinal = '';
    this.dataPeriodoReferenciaInicio = '';
    this.dataPeriodoReferenciaFim = '';
    this.rangePrazo.reset();
    this.rangePeriodoReferencia.reset();
  }

  isDisabled(): boolean {
    const checker = this._emptyCheckers.get(this.filters_data.type);
    return checker ? checker() : false;
  }

  private isContractEmpty(): boolean {
    const values = this.formContract.value;
    return !values.prorrogavelAte && !values.medidaProrrogavelAte &&
           !this.searchControlContract.value && !this.searchControlEntidades.value &&
           !this.range?.value?.start && !this.range?.value?.end &&
           !this.rangeDataAssinatura?.value?.start && !this.rangeDataAssinatura?.value?.end &&
           !this.rangeDataEficacia?.value?.start && !this.rangeDataEficacia?.value?.end &&
           !this.dataEficaciaInicio && !this.dataEficaciaFinal &&
           !this.dataAssinaturaInicio && !this.dataAssinaturaFinal &&
           !this.dataInicio && !this.dataFinal &&
           !this.entidade && !this.tipoContract;
  }

  private isServicosAmpliacaoEmpty(): boolean {
    const values = this.formServicoAmpliacao.value;
    return !values.codigo && !values.idTipoObra && !values.kmInicial &&
           !values.kmFinal && !values.prazoVigenteInicial &&
           !values.prazoVigenteFinal && !values.kmExtensao;
  }

  private isAfericaoAmpliacaoEmpty(): boolean {
    const values = this.formAfericaoAmpliacao.value;
    return values.anoConclusao === null &&
    (values.idsMunicipios === null || values.idsMunicipios.length === 0) &&
    values.rodovia === '' &&
    values.kmInicial === null &&
    values.kmFinal === null &&
    values.prazoVigenteFinal === null &&
    !values.nomeOrigemObra &&
    !values.nomeTipoObra &&
    !values.sentido &&
    !values.segmentoHomogeneo &&
    !values.kmCampoInicialInicio &&
    !values.kmCampoInicialFim &&
    !values.kmCampoFinalInicio &&
    !values.kmCampoFinalFim &&
    !values.naturezaPrazo &&
    !values.prazoInicialInicio &&
    !values.prazoInicialFim &&
    !values.prazoFinalInicio &&
    !values.prazoFinalFim &&
    !values.prazoVigenteInicialInicio &&
    !values.prazoVigenteInicialFim &&
    !values.prazoVigenteFinalInicio &&
    !values.prazoVigenteFinalFim &&
    !values.valorObraInicio &&
    !values.valorObraFim &&
    !values.valorObraAtualizadoInicio &&
    !values.valorObraAtualizadoFim &&
    !values.latitudeInicialInicio &&
    !values.latitudeInicialFim &&
    !values.latitudeFinalInicio &&
    !values.latitudeFinalFim &&
    !values.longitudeInicialInicio &&
    !values.longitudeInicialFim &&
    !values.longitudeFinalInicio &&
    !values.longitudeFinalFim &&
    !this.dataPrazoInicialInicio &&
    !this.dataPrazoInicialFim &&
    !this.dataPrazoFinalInicio &&
    !this.dataPrazoFinalFim &&
    !this.dataPrazoVigenteInicialInicio &&
    !this.dataPrazoVigenteInicialFim &&
    !this.dataPrazoVigenteFinalInicio &&
    !this.dataPrazoVigenteFinalFim;
  }

  onMedidaValorChange(valorSelecionado: string): void {
    const campoValor = this.form.get('valor');
    if (!campoValor) return;
    if (this.shouldDisableValorField(valorSelecionado)) {
      campoValor.reset();
      campoValor.disable();
    } else {
      campoValor.enable();
    }
  }

  private shouldDisableValorField(valor: string): boolean {
    return valor === 'Existe' || valor === 'Não Existe';
  }
  getAreasFuncionais(): void {
  this.relatoriosContratuaisService.getAreasFuncionais()
    .pipe(take(1))
    .subscribe({
      next: (results: any) => {
        this.areasFuncionais = results?.content ?? [];
      },
      error: (erro: any) => {
        this.toastService.showError('Erro ao buscar tipos de parecer.');
      }
    });
}
 getTiposRelatoriosContratuais(): void {
    this.relatoriosContratuaisService.getTipoRelatorio()
      .pipe(take(1))
      .subscribe({
        next: (results: any) => {
          this.tiposRelatorios = results?.content ?? [];
        },
        error: (erro: any) => {
          this.toastService.showError('Erro ao buscar tipos de parecer.');
        }
      });
  }
  getNomeRelatorio(): void {
    this.relatoriosContratuaisService.getNomeRelatorio()
      .pipe(take(1))
      .subscribe({
        next: (results: any) => {
          this.nomesRelatorios = results?.content ?? [];
        },
        error: (erro: any) => {
          this.toastService.showError('Erro ao buscar tipos de parecer.');
        }
      });
  }
    getTiposRelatorios(): void {
    this.relatoriosOperacionaisService.getTipoRelatorio()
      .pipe(take(1))
      .subscribe({
        next: (results: any) => {
          this.tiposRelatoriosOperacionais = results?.content ?? [];
        },
        error: (erro: any) => {
          this.toastService.showError('Erro ao buscar tipos de parecer.');
        }
      });
  }
  getTiposObra(idContrato:any){
    this.projetosService.getParametrosServicos(idContrato).subscribe({
      next: (res: any) => (this.tiposObra = res.content),
      error: err => console.error('Erro ao carregar tipos', err)
    });
  }
  getTiposProjetos(){
    this.projetosService.getTiposProjetos().subscribe({
      next: (res: any) => (this.tiposProjetos = res.content),
      error: err => console.error('Erro ao carregar tipos', err)
    });
  }
  getAnosDisponiveis(){
    this.feriadoService.getAnosDisponiveis().subscribe({
      next: (res: any) => (this.arrayAnos = res),
      error: err => console.error('Erro ao carregar tipos', err)
    });
  }
  getTiposInvestimentos(){
    this.projetosService.getTiposInvestimentos().subscribe({
      next: (res: any) => (this.tiposInvestimentos = res.content),
      error: err => console.error('Erro ao carregar tipos', err)
    });
  }
    getEntitieTypes() {

      this.entitieService
        .getEntitiesTypes()
        .pipe(take(1))
        .subscribe(
          (resp: any) => {
            this.entities = resp;
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )

  }
    getProfiles() {

      this.profileService
        .getProfiles()
        .pipe(take(1))
        .subscribe(
          (response: any) => {
            this.perfisUsuario = response.content;
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
  }

  carregarTipos(nome?: string) {
    this.ampliacaoService.getTiposObra(0, 50, nome).subscribe({
      next: (res: any) => (this.tiposObra = res.content),
      error: err => console.error('Erro ao carregar tipos', err)
    });
    this.ampliacaoService.getOrigensObra(0, 50, nome).subscribe({
      next: (res: any) => (this.origensObra = res.content),
      error: err => console.error('Erro ao carregar origens', err)
    });
  }

  blockNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '—') {
      event.preventDefault();
    }
  }
  preventNegativePaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (isNaN(Number(pasted)) || Number(pasted) < 0) {
      event.preventDefault();
    }
  }

  // reordenarMunicipios(): void {
  //   const selecionados = this.formAfericaoAmpliacao.value.idsMunicipios;
  //   this.municipiosOrdenados = [
  //     ...this.municipios.filter(m => selecionados.includes(m.id)),
  //     ...this.municipios.filter(m => !selecionados.includes(m.id))
  //   ];
  // }
  limitYear(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.value.startsWith('-')) {
      input.value = input.value.replace('-', '');
    }
    if (input.value.length > 4) {
      input.value = input.value.slice(0, 4);
    }
  }

  onOptionSelectedContract(event: any) {
    this.selectedOptionContract = event.option.value;
    this.searchControlContract.setValue(this.selectedOptionContract.name, { emitEvent: false });
    this.tipoContract = this.selectedOptionContract.name;
    this.filteredOptionsContract = [];
  }
  onOptionSelectedContracts(event: any) {
    this.selectedOptionContracts = event.option.value;
    this.searchControlContracts.setValue(this.selectedOptionContracts.contractName, { emitEvent: false });
    this.formAfericaoInicial.patchValue({ contractName: this.selectedOptionContracts.contractName });
    this.formAfericaoRelatorio.patchValue({ contractName: this.selectedOptionContracts.contractName });
    this.formAfericaoOperacional.patchValue({ contractName: this.selectedOptionContracts.contractName });
    this.filteredOptionsContracts = [];
  }
  onOptionSelectedContractsActives(event: any) {
    this.selectedOptionContractsActives = event.option.value;
    this.searchControlContractsActives.setValue(this.selectedOptionContractsActives.contractName, { emitEvent: false });

    if (this.isAnalisesProjetoFilter()) {
      const contratoDisplay = `${this.selectedOptionContractsActives.contractNumber} - ${this.selectedOptionContractsActives.contractName}`;
      this.searchControlContractsActives.setValue(contratoDisplay, { emitEvent: false });
      this.formAnalisesProjeto.patchValue({ idContrato: this.selectedOptionContractsActives.id, contratoDisplay, idObra: '', obraDisplay: '' });
      this.getObrasAnalisesProjeto(this.selectedOptionContractsActives.id);
    } else {
      this.formProjetos.patchValue({ contractNumber: this.selectedOptionContractsActives.contractNumber });
      this.getTiposObra(this.selectedOptionContractsActives.id);
    }

    this.filteredOptionsContracts = [];
  }

  getObrasAnalisesProjeto(idContrato: any): void {
    this.analisesProjetoService.getFiltrosObras(idContrato).subscribe({
      next: (res: any) => (this.obrasAnalisesProjeto = res || []),
      error: err => console.error('Erro ao carregar obras', err)
    });
  }

  onObraAnalisesProjetoChange(idObra: any): void {
    const obra = this.obrasAnalisesProjeto.find((item: any) => item.id === idObra);
    this.formAnalisesProjeto.patchValue({ obraDisplay: obra ? `${obra.codigo} - ${obra.descricaoServico}` : '' });
  }

  onOptionSelectedResponsavelAnalise(event: any) {
    this.selectedOptionResponsavelAnalise = event.option.value;
    this.searchControlResponsavelAnalise.setValue(this.selectedOptionResponsavelAnalise.nome, { emitEvent: false });
    this.formAnalisesProjeto.patchValue({
      idResponsavel: this.selectedOptionResponsavelAnalise.id,
      responsavelDisplay: this.selectedOptionResponsavelAnalise.nome,
    });
    this.filteredOptionsResponsavelAnalise = [];
  }
  onOptionSelectedRelatorios(event: any) {
    this.selectedOptionRelatorios = event.option.value;
    this.searchControlRelatorios.setValue(this.selectedOptionRelatorios.relatorio.nome, { emitEvent: false });
    this.formAfericaoRelatorio.patchValue({ nomeRelatorio: this.selectedOptionRelatorios.relatorio.nome });
    this.filteredOptionsRelatorios = [];
  }
  selectContract(contractName: string) {
    this.tipoContract = contractName;
  }

  onOptionSelectedEntidade(event: any) {
    this.selectedOptionEntidade = event.option.value;
    this.searchControlEntidades.setValue(this.selectedOptionEntidade.razaoSocial, { emitEvent: false });
    this.entidade = this.selectedOptionEntidade.razaoSocial;
    this.filteredOptionsEntidades = [];
  }
  selectEntitie(entitieName: string) {
    this.entidade = entitieName;
  }

  // Métodos para o template
  isEntitieFilter(): boolean { return this.filters_data.type === 'entitie'; }
  isUserFilter(): boolean { return this.filters_data.type === 'user'; }
  isContractFilter(): boolean { return this.filters_data.type === 'contract'; }
  isServicosIniciaisFilter(): boolean { return this.filters_data.type === 'servicosIniciais'; }
  isServicosAmpliacaoFilter(): boolean { return this.filters_data.type === 'servicosAmpliacao'; }
  isAfericaoInicialFilter(): boolean { return this.filters_data.type === 'afericaoInicial'; }
  isAfericaoRelatorioFilter(): boolean { return this.filters_data.type === 'afericaoRelatorio'; }
  isAfericaoAmpliacaoFilter(): boolean { return this.filters_data.type === 'afericaoAmpliacao'; }
  isRelatorioOperacionalFilter(): boolean { return this.filters_data.type === 'relatorioOperacional'; }
  isRelatorioContratualFilter(): boolean { return this.filters_data.type === 'relatorioContratual'; }
  isAfericaoOperacionalFilter(): boolean { return this.filters_data.type === 'afericaoOperacional'; }
  isProjetosFilter(): boolean { return this.filters_data.type === 'projetos'; }
  isFeriadosFilter(): boolean { return this.filters_data.type === 'feriados'; }
  isAnalisesProjetoFilter(): boolean { return this.filters_data.type === 'analisesProjeto'; }


  shouldShowClearButton(): boolean {
    return this.isContractFilter() || this.isServicosIniciaisFilter() || this.isServicosAmpliacaoFilter() ||
           this.isAfericaoInicialFilter() || this.isAfericaoRelatorioFilter() || this.isAfericaoAmpliacaoFilter()
           || this.isRelatorioOperacionalFilter() || this.isRelatorioContratualFilter() || this.isAfericaoOperacionalFilter()
           || this.isProjetosFilter() || this.isFeriadosFilter() || this.isAnalisesProjetoFilter();
  }

  shouldShowFilterAndClearButtons(): boolean {
    return this.isContractFilter() || this.isServicosIniciaisFilter() || this.isServicosAmpliacaoFilter() ||
           this.isAfericaoInicialFilter() || this.isAfericaoRelatorioFilter() || this.isAfericaoAmpliacaoFilter()
           || this.isRelatorioOperacionalFilter() || this.isRelatorioContratualFilter() || this.isAfericaoOperacionalFilter()
           || this.isProjetosFilter() || this.isUserFilter() || this.isFeriadosFilter() || this.isAnalisesProjetoFilter();
  }

  isEntitieFilterDisabled(): boolean {
    return !this.cepEnable && !this.cpfEnable && !this.emailEnable && !this.nameEnable;
  }

  getServicosIniciaisWidth(isPeriodo: boolean | undefined): string {
    return isPeriodo ? '22%' : '48%';
  }

  getFormControlColor(control: AbstractControl | null): string {
    return control?.touched && (control?.errors?.['required'] || control?.errors?.['minlength']) ? 'red' : 'rgb(102, 102, 102)';
  }


  getClearButtonText(): string {
    if (this.isContractFilter() || this.isAfericaoAmpliacaoFilter()) {
      return 'Voltar';
    }
    if (this.isServicosIniciaisFilter() || this.isServicosAmpliacaoFilter() || this.isAfericaoInicialFilter() || this.isAfericaoRelatorioFilter() || this.isRelatorioOperacionalFilter()
      || this.isRelatorioContratualFilter() || this.isAfericaoOperacionalFilter() || this.isFeriadosFilter()) {
      return 'Cancelar';
    }
    return 'Limpar';
  }

  processYearRange(event: any): void {
  const value: string = event.target.value;
  const cleanedValue = value.replace(/\s/g, ''); // Remove todos os espaços em branco

  let startYear: number | null = null;
  let endYear: number | null = null;

  // Tenta capturar o formato YYYY-YYYY
  const rangeRegex = /^(\d{4})-(\d{4})$/;
  const rangeMatch = cleanedValue.match(rangeRegex);

  // Tenta capturar o formato YYYY
  const singleYearRegex = /^(\d{4})$/;
  const singleYearMatch = cleanedValue.match(singleYearRegex);

  if (rangeMatch) {
    // Formato YYYY-YYYY encontrado
    const tempStart = parseInt(rangeMatch[1], 10);
    const tempEnd = parseInt(rangeMatch[2], 10);

    if (tempStart <= tempEnd) {
      startYear = tempStart;
      endYear = tempEnd;
    } else {
      console.error('O ano de início deve ser menor ou igual ao ano de fim.');
      this.formAfericaoAmpliacao.get('anoConclusao')?.setErrors({ 'invalidRange': true });
    }
  } else if (singleYearMatch) {
    // Formato YYYY encontrado
    startYear = parseInt(singleYearMatch[1], 10);
    endYear = null; // Zera o ano final, já que é um único ano
  } else {
    // Nenhum formato válido encontrado
    console.error('Formato de ano inválido. Use YYYY ou YYYY - YYYY.');
    this.formAfericaoAmpliacao.get('anoConclusao')?.setErrors({ 'invalidFormat': true });
  }

  // Atualiza os FormControls com os valores determinados acima
  this.formAfericaoAmpliacao.patchValue({
    anoConclusaoInicio: startYear,
    anoConclusaoFim: endYear
  });
}
// Função para aplicar a máscara YYYY - YYYY
  applyYearRangeMask(event: any): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove tudo que não for dígito
    let cleanedValue = value.replace(/\D/g, '');

    if (cleanedValue.length > 8) {
      cleanedValue = cleanedValue.substring(0, 8);
    }

    if (cleanedValue.length > 4) {
      // Adiciona a máscara " - "
      cleanedValue = cleanedValue.substring(0, 4) + ' - ' + cleanedValue.substring(4);
    }

    // Atualiza o valor do input no DOM
    input.value = cleanedValue;

    // Atualiza o valor do FormControl para a lógica de validação
    this.formAfericaoAmpliacao.get('anoConclusao')?.setValue(cleanedValue, { emitEvent: false });
  }
processKmRange(event: any, controlName: 'kmInicial' | 'kmFinal'): void {
  const value: string = event.target.value;
  const parts = value.split(' - ').map(part => {
    // Remove os zeros à esquerda e converte para número
    const num = parseInt(part.replace(/^0+/, ''), 10);
    return isNaN(num) ? null : num;
  });

  const initialProp = `${controlName}Inicio`;
  const finalProp = `${controlName}Fim`;

  let startKm: number | null = null;
  let endKm: number | null = null;

  if (parts.length === 2 && parts[0] !== null && parts[1] !== null) {
    if (parts[0] <= parts[1]) {
      startKm = parts[0];
      endKm = parts[1];
    } else {
      this.formAfericaoAmpliacao.get(controlName)?.setErrors({ 'invalidRange': true });
      return;
    }
  } else if (parts.length === 1 && parts[0] !== null) {
    startKm = parts[0];
    endKm = null;
  } else {
    this.formAfericaoAmpliacao.get(controlName)?.setErrors({ 'invalidFormat': true });
    startKm = null;
    endKm = null;
  }

  this.formAfericaoAmpliacao.patchValue({
    [initialProp]: startKm,
    [finalProp]: endKm
  });
}
applyKmMask(event: any, controlName: 'kmInicial' | 'kmFinal'): void {
  const input = event.target as HTMLInputElement;
  let value = input.value;

  // Remove tudo que não for dígito
  let cleanedValue = value.replace(/\D/g, '');

  let formattedValue = '';

  // Garante que a primeira parte tenha até 4 dígitos
  let firstPart = cleanedValue.substring(0, 4);

  if (cleanedValue.length > 4) {
    // Garante que a segunda parte tenha até 4 dígitos
    let secondPart = cleanedValue.substring(4, 8);
    formattedValue = `${firstPart} - ${secondPart}`;
  } else {
    formattedValue = firstPart;
  }

  input.value = formattedValue;
  this.formAfericaoAmpliacao.get(controlName)?.setValue(formattedValue, { emitEvent: false });
}

  formatarValor(event: Event, campo: any, form:any): void {
    const input = event.target as HTMLInputElement;
    let valor = input.value;

    // Remove tudo que não seja número
    valor = valor.replace(/\D/g, '');
    if (valor.length > 2) {
      // Insere vírgula para as duas casas decimais
      valor = valor.slice(0, -2) + ',' + valor.slice(-2);
    }
    // Adiciona pontos como separadores de milhar
    valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // Atualiza o valor do campo e o FormControl
    input.value = valor;
    form.get(campo)?.setValue(valor);
  }

  filterMunicipalities(inputValue:string){
    this.carregarMunicipios(inputValue);
  }

   filterMunicipios(nome: string): void {
      const searchTerm = nome.toLowerCase();
      this.carregarMunicipios(searchTerm);

  }
  isValidObra(): void {
    if (!this.selectedOptionContractsActives) {
      this.toastService.showError('Selecione um contrato para continuar');
      return;
    }
  }
perfilSelecionado(event: any){
  let perfilEquivalente;
  perfilEquivalente = this.perfisUsuario.find(perfil => perfil.id == event.value);
  this.labelPerfilSelecionado = perfilEquivalente.nome;
}
}
